<style lang="less">
    .dropbox-container {
        position: relative;
        background: #f9f9fb;
        flex: 1;
        height: 100%;
        overflow: auto;
        padding: 60px 60px 60px 60px;
        font: 14px/1.2 Open Sans, Tahoma, sans-serif, Source Han Sans CN, Helvetica Neue, Helvetica;
        .save-as-title {
            color: #000;
            font-size: 18px;
            cursor: pointer;
            display: flex;
            div {
                margin-right: 4px;
            }
            .selected-path {
                font-weight: bold;
            }
        }
        .files-folders-list {
            overflow: auto;
            margin-top: 20px;
            .folder-item {
                transition: all 0.2s ease-in-out;
                height: 50px;
                width: 100%;
                box-sizing: border-box;
                cursor: pointer;
                user-select: none;
                position: relative;
                display: flex;
                -webkit-box-align: center;
                align-items: center;
                font-size: 12px;
                img {
                    margin: 0 10px;
                }
                .folder-text {
                    height: 100%;
                    background: transparent;
                    color: #000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 0 5px;
                    box-sizing: border-box;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    user-select: none;
                }
                span {
                    height: 100%;
                    background: transparent;
                    color: #000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 0 5px;
                    box-sizing: border-box;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    user-select: none;
                    margin-left: 8px;
                    flex: 1;
                    padding-right: 20px;
                }
                .file-time {
                    white-space: nowrap;
                    font-size: 14px;
                    min-width: 200px;
                }
                .file-size {
                    white-space: nowrap;
                    font-size: 14px;
                    min-width: 80px;
                }
                .folder-rename {
                    height: 100%;
                    background: transparent;
                    color: #000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 0 5px;
                    box-sizing: border-box;
                    border: none;
                    outline: none;
                    display: flex;
                    align-items: center;
                    width: 100%;
                }
                &:hover {
                    background: #f2f3f6;
                }
            }
        }
        .files-box-list {
            overflow: auto;
            .files-item {
                width: 100%;
                height: 50px;
                margin-right: 60px;
                text-align: center;
                font-size: 13px;
                cursor: pointer;
                position: relative;
                user-select: none;
                display: flex;
                -webkit-box-align: center;
                align-items: center;
                img {
                    margin: 0 10px;
                    width: 21px;
                    height: 25px;
                    object-fit: cover;
                }
                span {
                    height: 100%;
                    background: transparent;
                    color: #000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 0 5px;
                    box-sizing: border-box;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    user-select: none;
                    flex: 1;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    margin-right: 20px;
                }
                .file-rename {
                    height: 100%;
                    background: transparent;
                    color: #000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 0 5px;
                    box-sizing: border-box;
                    border: none;
                    outline: none;
                    display: flex;
                    align-items: center;
                    width: 100%;
                }
                .file-time {
                    white-space: nowrap;
                    font-size: 14px;
                    min-width: 200px;
                    text-align: left;
                }

                .file-size {
                    white-space: nowrap;
                    font-size: 14px;
                    min-width: 80px;
                    text-align: left;
                }

                &:hover {
                    color: #638bfc;
                    background: #f2f3f6;
                }
            }
        }
    }
</style>

<template>
    <div class="dropbox-container">
        <div class="save-as-title">
            <div :class="{ 'selected-path': dropboxPath.length == 0 }" @click="setDropboxPath(null)">EdrawMax</div>
            <div
                v-for="(item, index) in dropboxPath"
                :key="index"
                :class="{ 'selected-path': dropboxPath.length == index + 1 }"
                @click="setDropboxPath(index)"
            >
                > {{ item }}
            </div>
        </div>
        <div class="files-folders-list">
            <div class="folder-item" style="background: #fff; border: 1px solid #eee; height: 40px">
                <span>{{ $t("name") }}</span>
                <div class="file-time">{{ $t("time") }}</div>
                <div class="file-size">{{ $t("size") }}</div>
            </div>
            <div class="folder-item" v-for="(item, index) in dropboxFolderList" :key="index" @dblclick="openDropBoxFolder(item)">
                <img :src="require('@/home/assets/img/files/folder-list.svg')" />
                <div class="folder-text" style="">{{ item.name }}</div>
            </div>
        </div>
        <div class="files-box-list">
            <div class="files-item" v-for="(item, index) in dropboxFilesList" @dblclick="openFile(item['path_display'])" :key="index">
                <img :src="require('@/home/assets/img/files/file-list.svg')" />
                <span>{{ item.name }}</span>
                <div class="file-time">{{ new Date(item.client_modified).toLocaleString() }}</div>
                <div class="file-size">{{ (item.size / 1000).toFixed(2) }}KB</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import { Dropbox } from "dropbox";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {},
    })
    export default class Files extends Vue {
        dropboxPath = [];
        dbx = null;
        dropboxFolderList = [];
        dropboxFilesList = [];
        //生命周期
        mounted() {
            window.onstorage = (e) => {
                if (e.key == "dropbox_access_token") {
                    this.dbx = new Dropbox({
                        accessToken: e.newValue,
                    });
                    this.dropboxPath = [];
                    this.getDropBoxFloder("");
                }
            };
        }

        created() {
            if (this.userInfo) {
                this.init();
            } else {
                this.$bus.$on("loginSucc", () => {
                    this.init();
                });
            }
        }
        init() {
            let dropboxToken = localStorage.getItem("dropbox_access_token");
            if (!dropboxToken) {
                this.dbx = new Dropbox({
                    clientId: "5bt9id87y41ps12",
                });
                let org = window.location.origin + (<any>this.$router).options.base + "dropboxcallback";
                // location.href = authurl;

                let authurl = this.dbx.getAuthenticationUrl(org);
                window.open(authurl);
            } else {
                this.dbx = new Dropbox({
                    accessToken: dropboxToken,
                });
                this.dropboxPath = [];
                this.getDropBoxFloder("");
            }
        }

        get userInfo() {
            return this.$store.state.userInfo;
        }

        setDropboxPath(index) {
            if (index === null) {
                this.getDropBoxFloder("");
                this.dropboxPath = [];
            } else {
                let len = this.dropboxPath.length - 1 - index;
                for (let i = 0; i < len; i++) {
                    this.dropboxPath.pop();
                }
                let prefix = "/" + this.dropboxPath.join("/") + "/";
                this.getDropBoxFloder(prefix);
            }
        }

        openDropBoxFolder(item) {
            this.dropboxPath.push(item.name);
            let prefix = "/" + this.dropboxPath.join("/") + "/";
            this.getDropBoxFloder(prefix);
        }

        getDropBoxFloder(prefix) {
            this.$store.commit("setState", { data: true, type: "showLoading" });
            this.dropboxFolderList = [];
            this.dropboxFilesList = [];
            this.dbx
                .filesListFolder({ path: prefix, recursive: true })
                .then((res) => {
                    let folders = res.entries.filter((item) => {
                        return (
                            item[".tag"] == "folder" &&
                            item["name"] != this.dropboxPath[this.dropboxPath.length - 1] &&
                            item["path_display"].split("/").length == this.dropboxPath.length + 2
                        );
                    });
                    let files = res.entries.filter((item) => {
                        return item[".tag"] == "file" && item["name"].endsWith(".eddx");
                    });
                    this.dropboxFolderList = folders;
                    this.dropboxFilesList = files;
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                })
                .catch((err) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                });
        }

        openFile(path) {
            let winName = btoa(encodeURIComponent(path)),
                href = window.location.origin + (<any>this.$router).options.base + "app.html?type=dropbox&obj=" + path;

            let winref = window.open("", winName);
            if (winref.location.href === "about:blank") {
                winref.location.href = href;
            }
        }
    }
</script>

<i18n>
{
  "zh": {
    "name": "名称",
    "time": "时间",
    "size": "大小"
  },
  "en": {
    "name": "Name",
    "time": "Time",
    "size": "Size"
  },
  "fr": {
    "name": "Nom",
    "time": "Temps",
    "size": "Taille"
  },
  "de": {
    "name": "Name",
    "time": "Datum",
    "size": "Größe"
  },
  "jp": {
    "name": "名称",
    "time": "时间",
    "size": "大小"
  },
  "es": {
    "name": "Nombre",
    "time": "Hora",
    "size": "Talla"
  },
  "pt": {
    "name": "Nome",
    "time": "Hora",
    "size": "Tamanho"
  },
  "it": {
    "name": "Nome",
    "time": "Ora",
    "size": "Dimensione"
  },
  "tw": {
    "name": "名稱",
    "time": "時間",
    "size": "大小"
  },
  "kr": {
    "name": "이름",
    "time": "시간",
    "size": "크기"
  },
  "id": {
    "name": "Nama",
    "time": "Waktu",
    "size": "Ukuran"
  }
}
</i18n>
